import { Button, Drawer, Form } from 'antd';
import { Formik } from 'formik';
import React, { Dispatch, SetStateAction } from 'react';
import { brazilianStates } from '../../../../utils/selects';
import InputComponent from '../../../atoms/InputComponet';
import InputMaskComponent from '../../../atoms/InputMaskComponent';
import SelectComponent from '../../../atoms/SelectComponent';
import { validationSchemaAddress } from './schema';
import customerStore from '../../../../stores/customerStore';
import { v4 as uuidv4 } from 'uuid';

interface DrawerAddressProps {
    isModalOpen?: boolean;
    setIsModalOpen: Dispatch<SetStateAction<boolean>>;
}

const DrawerAddress: React.FC<DrawerAddressProps> = ({ isModalOpen, setIsModalOpen }) => {
    const handleSubmit = async (values: any) => {
        const createProps = {
            ...values,
            state: values.state.value,
            newAddress: true,
            uuid: uuidv4(),
        };

        customerStore.addAddress(createProps);
        setIsModalOpen(false);
    };

    const initialValuesForm = {
        refAddress: '',
        block: '',
        city: '',
        number: '',
        addressName: '',
        street: '',
        state: { value: '', label: '' },
    };

    return (
        <Formik validationSchema={validationSchemaAddress} initialValues={initialValuesForm}
            onSubmit={async (values) => {
                await handleSubmit(values);
            }}
            enableReinitialize>
            {({ submitForm, resetForm }) => (
                <Drawer
                    title="Cadastrar Endereço"
                    width={540}
                    onClose={() => {
                        resetForm();
                        setIsModalOpen(false);
                    }}
                    open={isModalOpen}
                    footer={
                        <div className="flex gap-4 justify-end">
                            <Button onClick={() => setIsModalOpen(false)}>Cancelar</Button>
                            <Button type="primary" onClick={submitForm}>
                                Cadastrar
                            </Button>
                        </div>
                    }
                >
                    <Form>
                        <div className="flex flex-col gap-4">
                            <InputMaskComponent size="middle" mask="99999-999" label="Qual o CEP?" name="zipCode" id="zipCode" />

                            <InputComponent size="middle" label="Tipo de Endereço" name="addressName" id="addressName" />
                            <InputComponent size="middle" label="Endereço" name="street" id="street" />
                            <InputComponent size="middle" label="Bairro" name="block" id="block" />

                            <div className="flex gap-4">
                                <InputComponent size="middle" label="Cidade" name="city" id="city" />
                                <SelectComponent size="middle" label="Estado" name="state" options={brazilianStates} />
                            </div>

                            <InputComponent size="middle" label="Numero" name="number" id="number" />
                            <InputComponent size="middle" label="Complemento" name="addressComplement" id="addressComplement" />
                            <InputComponent size="middle" label="Ponto de Referencia (opcional)" name="refAddress" id="refAddress" />
                        </div>
                    </Form>
                </Drawer>
            )}
        </Formik>
    );
};

export default DrawerAddress;